<template>
  <div>
    <search></search>
    <div class="scoreChangeList clearfix_">
      <div class="RecommendBox">
        <div class="RecommendTitBox">
          <span>最新销售</span>
        </div>
        <div class="RecommendContentBox">
          <ul>
            <li v-for="(item,index) in salesGoods" :key="index">
              <router-link @click.native="flushCom" tag="a" target="_blank" :to="{name:'goodsdetails',query: {goodsId:item.goodsId,isSupplyChainGoods:2,supplyChainTenantId:item.supplyChainTenantId}}">
                <div class="RecommendPicBox">
                  <img :src="item.goodsHeadpicPath1?item.goodsHeadpicPath1:noImg"/>
                </div>
                <div class="RecommendNameBox">
                  <p>{{item.name}}</p>
                </div>
                <div class="RecommendPriceBox">
                  <p><span>{{item.price}}</span></p>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div ref="getH" class="GoodsContents">
        <div class="operationBox">
          <div class="goodsTop">
            <ul>
              <li style="width:54px;padding-left:0;" class="clearfix_" :class="{active:sortType==1}" @click="dateCreatedSort">
                <span style="margin:0;width:54px;text-align:center;">综合</span>
              </li>
              <li class="clearfix_ score_change_item" :class="{active:sortType==2}"  @click="sumSort">
                <span>销量</span>
                <img v-show="sumImgShow==0" :src="sortImg" alt="">
                <img v-show="sumImgShow==1" :src="descImg" alt="">
                <img v-show="sumImgShow==2" :src="ascImg" alt="">
              </li>
              <li class="clearfix_ score_change_item" :class="{active:sortType==3}" @click="priceSort">
                <span>价格</span>
                <img v-show="priceImgShow==0" :src="sortImg" alt="">
                <img v-show="priceImgShow==1" :src="descImg" alt="">
                <img v-show="priceImgShow==2" :src="ascImg" alt="">
              </li>
              <li class="clearfix_ score_change_item" :class="{active:sortType==4}" @click="scoreSort">
                <span>积分</span>
                <img v-show="scoreImgShow==0" :src="sortImg" alt="">
                <img v-show="scoreImgShow==1" :src="descImg" alt="">
                <img v-show="scoreImgShow==2" :src="ascImg" alt="">
              </li>
            </ul>
          </div>
        </div>
        <div class="GoodsListContentBox">
          <ul class="clearfix">
            <li v-for="(item,index) in scoreChangeList" :key="index" :data-id="item.id" @mouseenter="hover(index)" @mouseleave="leave(index)">
              <router-link tag="a" target="_blank" :to="{name:'goodsdetails',query: {goodsId:item.goodsId,isSupplyChainGoods:2,supplyChainTenantId:item.supplyChainTenantId}}">
                <div class="goodslistpicbox">
                  <img :title="item.name" :src="item.goodsHeadpicPath1?item.goodsHeadpicPath1:noImg" width="225" height="225" :goodsId="item.goodsId"/>
                </div>
              </router-link>
                <div class="goodslistprice clearfix_">
                  <p class="fl">{{item.price}} + {{item.score}}分</p>
                </div>
              <router-link tag="a" target="_blank" :to="{name:'goodsdetails',query: {goodsId:item.goodsId,isSupplyChainGoods:2,supplyChainTenantId:item.supplyChainTenantId}}">
                <div class="goodslistnamebox">
                  <p :title="item.name">{{item.name}}</p>
                </div>
              </router-link>
              <div class="clearfix_">
                <div class="goodslistBtnBox fl" v-show="Accord === index" @click="goToGoods(item.goodsId,item.supplyChainTenantId)">查看详情</div>
                <div class="goodslistBtnBox fl" v-show="Accord === index" @click="goToGoods(item.goodsId,item.supplyChainTenantId)">加入购物车</div>
              </div>
            </li>
          </ul>
          <div class="noGoods" v-show="total==0">暂时没有商品哦~！快去看看其他好商品吧~！</div>
        </div>
        <div v-show="total" class="pagebox">
          <div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-size="12"
              layout="prev, pager, next, jumper"
              :total="this.total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
import search from '@/components/index/search'
export default {
  data(){
    return {
      sortType:0,
      page:1,
      pagesize:12,
      scoreChangeList:[],
      salesGoods:[],
      total:null,
      lastPage:0,
      Accord:-1,
      noImg:require("@/assets/img/aa.png"),
      sortImg:require("@/assets/img/a02.png"),
      descImg:require("@/assets/img/a04.png"),
      ascImg:require("@/assets/img/a03.png"),
      sumImgShow:0,
      priceImgShow:0,
      scoreImgShow:0,
      scoreSortNum:0,
      priceSortNum:0,
      sumSortNum:0
    }
  },
  components:{
    search
  },
  mounted:function(){
    var t_=this
    t_.getScorePromotionGoods()
    t_.getSalesGoods()
  },
  methods:{
    goToGoods:function(goodsId,supplyChainTenantId){
      var t_=this
      var href=this.$router.resolve( {name:'goodsdetails',query: {goodsId:goodsId,isSupplyChainGoods:2,supplyChainTenantId:supplyChainTenantId}})
      return window.open(href.href,'_blank')
    },
    dateCreatedSort:function(){
      var t_=this
      t_.sortType=1
      t_.scoreChangeList=[]
      t_.page=1
      t_.scoreSortNum=0
      t_.priceSortNum=0
      t_.sumSortNum=0
      t_.sumImgShow=0
      t_.priceImgShow=0
      t_.scoreImgShow=0
      t_.getScorePromotionGoods()
    },
    sumSort:function(){
      var t_=this
      t_.sortType=2
      t_.scoreChangeList=[]
      t_.page=1
      t_.scoreSortNum=0
      t_.priceSortNum=0
      t_.priceImgShow=0
      t_.scoreImgShow=0
      if(t_.sumSortNum===0) {
        t_.sumSortNum=1
        t_.sumImgShow=1
      }else if(t_.sumSortNum===1){
        t_.sumSortNum=2
        t_.sumImgShow=2
      }else if(t_.sumSortNum===2){
        t_.sumSortNum=1
        t_.sumImgShow=1
      }
      t_.getScorePromotionGoods()
    },
    priceSort:function(){
      var t_=this
      t_.sortType=3
      t_.scoreChangeList=[]
      t_.page=1
      t_.scoreSortNum=0
      t_.sumSortNum=0
      t_.sumImgShow=0
      t_.scoreImgShow=0
      if(t_.priceSortNum===0) {
        t_.priceSortNum=1
        t_.priceImgShow=1
      }else if(t_.priceSortNum===1){
        t_.priceSortNum=2
        t_.priceImgShow=2
      }else if(t_.priceSortNum===2){
        t_.priceSortNum=1
        t_.priceImgShow=1
      }
      t_.getScorePromotionGoods()
    },
    scoreSort:function(){
      var t_=this
      t_.sortType=4
      t_.scoreChangeList=[]
      t_.page=1
      t_.priceSortNum=0
      t_.sumSortNum=0
      t_.sumImgShow=0
      t_.priceImgShow=0
      if(t_.scoreSortNum===0){
        t_.scoreSortNum=1
        t_.scoreImgShow=1
      }else if(t_.scoreSortNum===1){
        t_.scoreSortNum=2
        t_.scoreImgShow=2
      }else if(t_.scoreSortNum===2){
        t_.scoreSortNum=1
        t_.scoreImgShow=1
      }
      t_.getScorePromotionGoods()
    },
    hover:function (index) {
      this.Accord = index
    },
    leave:function (index) {
      this.Accord = null
    },
    handleSizeChange(val){},
    handleCurrentChange(val){
      this.page=val
      window.scrollTo(0,0)
      this.getScorePromotionGoods(12,val)
    },
    getScorePromotionGoods:function(){
      var t_=this
      var data0bj={
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:'',
        page:t_.page,
        pagesize:t_.pagesize
      }
      if(t_.sortType==1)data0bj.sortName = 'dateCreated'
      if(t_.sortType==2){
        data0bj.sortName='sum'
        data0bj.sort=t_.sumSortNum
      }
      if(t_.sortType==3){
        data0bj.sortName='price'
        data0bj.sort=t_.priceSortNum
      }
      if(t_.sortType==4){
        data0bj.sortName='score'
        data0bj.sort=t_.scoreSortNum
      }
      axios.post(`${ip}formWorkInterface/getScorePromotionGoods`,Qs.stringify(data0bj)).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if( res.data.code==0){
          t_.scoreChangeList=res.data.results.rows
          t_.total=res.data.results.total
          t_.lastPage=res.data.results.lastPage
        }
      })
    },
    getSalesGoods:function(){
      var t_=this
      var data0bj = {
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:'',
        type:3,
        page:1,
        pagesize:5
      }
      axios.post(`${ip}formWorkInterface/salesGoods`,Qs.stringify(data0bj)).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if( res.data.code == 0 ){
          t_.salesGoods=res.data.results.rows
        }
      })
    }
  }
}
</script>
<style scoped>
  .scoreChangeList{
    width: 1200px;
    margin: 70px auto 70px;
  }
  .RecommendBox{
    width: 191px;
    /* height: 1390px; */
    border: 1px solid #EBEBEB;
    float: left;
  }
  .RecommendTitBox{
    width: 100%;
    text-align: center;
    height: 40px;
    line-height: 40px;
    color: #2c3e50;
    font-size: 14px;
    background: #FAFAFA;
    border-bottom: 1px solid #EBEBEB;
  }
  .RecommendContentBox ul li{
    margin-bottom: 20px;
    border-bottom: 1px solid #ebebeb;
  }
  .RecommendContentBox ul li:last-child{
    border-bottom: 0;
  }
  .RecommendContentBox ul li a{
    text-decoration: none;
  }

  .RecommendPicBox{
    padding: 10px;
  }
  .RecommendPicBox img{
    width: 100%;
    height: 100%;
  }
  .RecommendNameBox{
    padding: 10px;
    padding-top: 0;
    font-size: 12px;
  }
  .RecommendNameBox p{
    color: #000;
    line-height: 16px;
  }
  .RecommendNameBox p:hover{
    color: #FF6600;
    text-decoration: underline;
  }
  .RecommendPriceBox{
    padding: 10px;
    padding-top: 0;
    font-size: 22px;
  }
  .RecommendPriceBox p span{
    color: #FF6600;
  }
  .clearfix {
		overflow: auto;
		_height: 1%;
	}
  .GoodsContents{
    width: 991px;
    /* border: 1px solid #ccc; */
    float: left;
    margin-left: 14px;
  }
  .noGoods{
    text-align: center;
    margin-top: 30px;
  }
  .operationBox{
    width: 100%;
    height: 40px;
    background: #F6F6F6;
    border: 1px solid #ccc;
    margin-bottom: 8px;
  }
  .goodsTop{
    width: 992px;
    height: 40px;
    border-bottom: 1px solid #ccc;
    margin: 0 auto;
  }
  .goodsTop ul{
    width: auto;
    height: 30px;
    margin-top: 8px;
    float: left;
    margin-left: 8px;
  }
  .goodsTop ul li{
    float: left;
    background: white;
    margin-right: 5px;
    border: 1px solid #EDEDED;
  }
  .goodsTop ul .active{
    background: #e4393c;
    color: #fff;
    border: 1px solid #e4393c;
  }
  .goodsTop ul li .active_{
    background: url(../../assets/img/a01.png);
  }
  .goodsTop ul li:nth-child(2) .active1{
    background: url(../../assets/img/a03.png);
  }
  .goodsTop ul li:nth-child(2) .active2{
    background: url(../../assets/img/a04.png);
  }
  .goodsTop ul li:nth-child(3) .active1{
    background: url(../../assets/img/a03.png);
  }
  .goodsTop ul li:nth-child(3) .active2{
    background: url(../../assets/img/a04.png);
  }
  .goodsTop ul li i{
    display: block;
    float: left;
    width: 7px;
    height: 11px;
    background: url(../../assets/img/a00.png);
    margin-top: 7px;
  }
  .goodsTop ul li:nth-child(3) i,.goodsTop ul li:nth-child(2) i{
    background: url(../../assets/img/a02.png);
  }
  .pagebox{
    width: 100%;
    height: 40px;
    float: left;
    margin: 70px auto;
    text-align: center;
  }
  .xiaoliang{
    background: url('../../assets/img/icon.png') 21px -317px;
  }
  .pingjia{
    background: url('../../assets/img/icon.png') 21px -317px;
  }
  .jiage{
    background: url('../../assets/img/icon.png') 21px -356px
  }
  .goodsTop ul .frist{
    color: white;
    background: #FF6600;
    width: 59px;
  }
  .goodsTop ul li{
    display: block;
    width: 44px;
    height: 23px;
    border: 1px solid #ccc;
    line-height: 24px;
    font-size: 12px;
    background: white;
    float: left;
    cursor: pointer;
    padding-left: 10px;
  }
  .goodsTop ul .pricebtn{
    background: url(/static/img/icon.d55c0a9.png) no-repeat 32px -355px;
  }
  .goodsTop ul .pricebtn span{
    display: block;
    width: 34px;
    float: left;
  }
  .goodsTop ul .salebtn{
    background: url(/static/img/icon.d55c0a9.png) no-repeat 32px -355px;;
  }
  .goodsTop ul .salebtn span{
    display: block;
    width: 34px;
    float: left;
  }
  .goodsTop ul li span{
    float: left;
    margin-right: 5px;
  }
  /* .operationInput{
    float: left;
    margin: 7px;
    width: auto;
    height: auto;
  }
  .operationInput input{
    width: 50px;
    height: 20px;
    padding-left: 5px;
    outline: none;
  }
  .operationInput span{
    margin: 0 5px;
  }
  .operationInput button{
    margin-left: 5px;
    border: 1px solid #ccc;
    background: 0;
    height: 24px;
    width: 45px;
    border-radius: 2px;
    cursor: pointer;
  } */


  /*商品列表样式表*/
  .GoodsListContentBox{
    /* padding: 0 23px; */
  }
  .GoodsListContentBox ul li{
    width: 224px;
    height: 352px;
     padding: 10px;
    margin-right: 2px;
    float: left;
    margin-bottom: 10px;
    border: 1px solid white;
  }
  .GoodsListContentBox ul li:nth-child(4n+0){
    margin-right: 0;
  }
  .GoodsListContentBox ul li:hover{
    border: 1px solid #eaeaea;
    border-radius: 3px;
    box-shadow: 0 0 1px #999;
  }
  .GoodsListContentBox ul li a{
    text-decoration: none;
  }
  .goodslistpicbox{
    height: 235px;
    border-bottom: 1px solid #EEEEEE;
  }
  .goodslistprice p{
    height: 45px;
    line-height: 45px;
    text-align: left;
    color: #FF6600;
    font-size: 22px;
  }
  .goodslistnamebox p{
    text-align: left;
    font-size: 12px;
    color: #313030;
    height: 35px;
    line-height: 19px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .goodslistnamebox p:hover{
    color: #FF6600;
    text-decoration: underline;
  }
  .goodslistoptionbox{
    width: 100%;
    height: 30px;
  }
  .goodslistoptionbox .goodslistLeftBox{
    width: 50%;
    height: 35px;
    float: left;
    text-align: left;
    line-height: 35px;
    color: #313030;
  }
  .goodslistoptionbox .goodslistLeftBox span{
    color: #2272C8;
    font-weight: 600;
  }
  .goodslistoptionbox .goodslistRightBox{
    float: left;
    text-align: right;
    width: 50%;
    height: 35px;
    line-height: 35px;
    color: #313030;
  }
  .goodslistBtnBox{
    cursor: pointer;
    width: 112px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #FF6600;
    font-size: 14px;
    border-top: 1px solid #eee;
    margin-top: 10px;
    border-right: 1px solid #eee;
    /*display: none;*/
  }
  .goodslistBtnBox:first-child{
    width: 111px;
  }
  .goodslistBtnBox:last-child{
    border-right: 0;
  }
   /* .el-pagination .el-pagination__jump{
    margin-top:-10px;
  } */
  .goodslistprice  .teamPriceAndNum{
    font-size: 14px;
  }
  .goodslistprice  .teamPriceAndNum span{
    margin-right: 5px;
  }
  .goodslistprice  .teamPriceAndNum  i{
    width: 55px;
    height: 18px;
    background:#f60;
    line-height: 18px;
    text-align: center;
    color:#fff;
    margin-top: 13px;
  }
  .score_change_item img{
    margin-top:6px;
  }
  .pagebox .el-pagination__jump{
    margin-top:-9px;
  }
  .pagebox .el-pagination__jump .el-pagination__editor{
    top:9px;
  }
  @media screen and ( max-width: 1390px ) {
    .GoodsContents{
      width: 983px;
    }
    .goodsTop{
      width: 100%;
    }
    .GoodsListContentBox ul li{
      width: 233px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/scoreChange/scoreChange.vue